'use client'

import { useId } from 'react'
import clsx from 'clsx'

import Checkbox from 'shared/ui/form/Checkbox'
import { CheckboxProps } from 'shared/ui/form/Checkbox/Checkbox'
import Link from 'shared/ui/Link/Link'
import { PATHS } from 'shared/utils/paths'

import styles from './MarketingConsentCheckbox.module.scss'

interface MarketingConsentCheckboxProps
  extends Omit<CheckboxProps, 'label' | 'labelAddon'> {
  isExpanded: boolean
  onToggleExpanded: () => void
  controlsId?: string
  toggleDisabled?: boolean
  labelClassName?: string
  toggleClassName?: string
}

const MarketingConsentCheckbox = ({
  isExpanded,
  onToggleExpanded,
  controlsId,
  toggleDisabled,
  labelClassName,
  toggleClassName,
  ...checkboxProps
}: MarketingConsentCheckboxProps) => {
  const textId = `marketing-consent-text-${useId()}`

  return (
    <Checkbox
      {...checkboxProps}
      label={
        <span id={textId} className={clsx(styles.consentText, labelClassName)}>
          {!isExpanded ? (
            <>
              Wyrażam zgodę na otrzymywanie treści marketingowych i ofert
              handlowych od Lokalny Rolnik Sp. z o.o.
            </>
          ) : (
            <>
              Wyrażam zgodę na otrzymywanie treści marketingowych i ofert
              handlowych od Lokalny Rolnik Sp. z o.o. dostosowanych do moich
              preferencji informacji handlowych w postaci bezpłatnego
              newslettera (zawierającego w szczególności informacje o promocjach
              cenowych oraz kuponach rabatowych). Twoje dane osobowe będą
              przetwarzane zgodnie z przepisami{' '}
              <Link href={PATHS.privacy} rel='noreferrer' target='_blank'>
                Polityki Prywatności
              </Link>
            </>
          )}
        </span>
      }
      labelAddon={
        <button
          type='button'
          className={clsx(styles.expandToggle, toggleClassName)}
          aria-expanded={isExpanded}
          aria-controls={controlsId ?? textId}
          aria-disabled={toggleDisabled || undefined}
          onClick={toggleDisabled ? undefined : onToggleExpanded}
        >
          {isExpanded ? 'mniej' : 'więcej'}
        </button>
      }
    />
  )
}

export default MarketingConsentCheckbox
